module.exports = __webpack_public_path__ + "static/media/logo2.56bf91cc.png";